import { useEffect, useState } from 'react';

function CheckboxSelectAlllRegistrations({
  registrations,
  batchSelectedRegistrations,
  setBatchSelectedRegistrations,
  slice,
  className,
  includeText,
  id,
}) {
  const [allOnCurrentPageSelected, setAllOnCurrentPageSelected] =
    useState(false);

  useEffect(() => {
    const registrationsRacingNumbers = batchSelectedRegistrations?.map(
      (r) => r.racingNumber
    );
    const sliceRacingNumbers = slice.map((s) => s.racingNumber);

    const allElementsOnPageSelected = sliceRacingNumbers.every((elem) =>
      registrationsRacingNumbers?.includes(elem)
    );

    setAllOnCurrentPageSelected(allElementsOnPageSelected);
  }, [slice, batchSelectedRegistrations]);

  return (
    <div className='d-inline-flex gap-2 align-items-center'>
      <input
        id={id}
        type='checkbox'
        checked={
          allOnCurrentPageSelected ||
          registrations?.length === batchSelectedRegistrations?.length
        }
        className={className}
        onChange={(e) => {
          if (e.target.checked) {
            let newArray = [...batchSelectedRegistrations];

            let elementsToAdd = slice.filter(
              (el) =>
                !newArray.some((_el) => _el.racingNumber === el.racingNumber)
            );

            newArray = [...newArray, ...elementsToAdd];

            setBatchSelectedRegistrations(newArray);
          } else {
            let newArray = [...batchSelectedRegistrations];
            newArray = newArray.filter((r) => !slice.includes(r));
            setBatchSelectedRegistrations(newArray);
          }
        }}
      />
      {includeText && <label htmlFor={id}>Markera alla</label>}
    </div>
  );
}

export default CheckboxSelectAlllRegistrations;
